export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode[VisibilityMode["EVERYONE"] = 0] = "EVERYONE";
    VisibilityMode[VisibilityMode["SIGNED_IN"] = 1] = "SIGNED_IN";
    VisibilityMode[VisibilityMode["TEAM"] = 2] = "TEAM";
})(VisibilityMode || (VisibilityMode = {}));
//# sourceMappingURL=visibility-mode.enum.js.map